<template>
  <div>
    <div v-if="!isReset">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('title.resetPassword') }}</h1>
      </div>

      <form v-on:submit.prevent="onSubmit">
        <b-field
          :type="{ 'is-danger': errors.has('password') }"
          :message="errors.first('password')"
        >
          <b-input
            type="password"
            :placeholder="$t('validation.attributes.password')"
            icon-pack="fas"
            icon="key"
            password-reveal
            v-model="password"
            name="password"
            v-validate="'required'"
            ref="password"
          />
        </b-field>
        <b-field
          :type="{ 'is-danger': errors.has('confirmPassword') }"
          :message="errors.first('confirmPassword')"
        >
          <b-input
            type="password"
            :placeholder="$t('validation.attributes.confirmPassword')"
            icon-pack="fas"
            icon="key"
            password-reveal
            name="confirmPassword"
            v-model="confirmPassword"
            v-validate="'required|confirmed:password'"
          />
        </b-field>
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <button class="button is-vcentered is-primary login-button">
              {{ $t('button.save') }}
            </button>
          </p>
        </div>
      </form>
    </div>
    <div v-else-if="isReset">
      <div class="has-text-centered membership-header">
        <h1 class="is-size-5 has-text-weight-bold">{{ $t('description.passwordReset') }}.</h1>
        <h2 class="is-size-6">{{ $t('description.canLoginWithEmailAndPassword') }}</h2>
      </div>
      <div class="field is-grouped is-grouped-centered">
        <router-link class="button is-vcentered is-primary login-button" :to="{ name: 'login' }">
          <strong>{{ $t('button.login') }}</strong>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../_api/api.service'

export default {
  data() {
    return {
      password: null,
      confirmPassword: null,
      token: null,
      isReset: false
    }
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          ApiService.post('/auth/resetpassword', {
            password: this.password,
            token: this.token
          }).then(data => {
            this.isReset = data.isValid
          })
        }
      })
    }
  },
  mounted() {
    const { token } = this.$route.query
    this.token = token
    if (!token) {
      this.$router.push({ name: 'forgotPassword' })
    }
  }
}
</script>
